// ------------------------------------------------------------
// First Created: 06 Jan 2026
// Author: Atul Pandey
// Purpose:
// Build canonical performance time series for a single action
// Used by:
// - Self Performance Chart
// - Collective Performance Chart (frontend aggregation)
// ------------------------------------------------------------

import moment from "moment-timezone";

export const buildActionTimeSeries = (
  action,
  {
    granularity = "day",        // day | week | month
    timezone = action?.userTimeZone || "UTC",
  } = {}
) => {
  if (!action) return [];

  let cumulative = 0;
  const series = [];

  const bucketStart = (date) =>
    moment(date)
      .tz(timezone)
      .startOf(granularity)
      .format("YYYY-MM-DD");

  // ----------------------------------------------------------
  // Recurring Action
  // ----------------------------------------------------------
  if (action.actionRecurrencePattern !== "OneTime") {
    const logs = (action.recurringActionLog || [])
      .filter((log) => log?.actualValue !== undefined)
      .sort((a, b) => new Date(a.logDate) - new Date(b.logDate));

    logs.forEach((log) => {
      const dateKey = bucketStart(log.logDate);
      const delta = log.actualValue ?? 0;

      cumulative += delta;

      series.push({
        dateKey,
        deltaActualValue: delta,
        cumulativeActualValue: cumulative,
      });
    });

    return series;
  }

  // ----------------------------------------------------------
  // OneTime Action
  // ----------------------------------------------------------
  const notes = (action.userActionNotes || [])
    .filter((note) => note?.actionNoteActualValue !== undefined)
    .sort(
      (a, b) =>
        new Date(a.actionNoteDate) - new Date(b.actionNoteDate)
    );

  notes.forEach((note) => {
    const dateKey = bucketStart(note.actionNoteDate);
    const value = note.actionNoteActualValue ?? 0;

    // For OneTime, notes already represent absolute actualValue
    cumulative = value;

    series.push({
      dateKey,
      deltaActualValue: value,
      cumulativeActualValue: cumulative,
    });
  });

  return series;
};